export enum ContentTemplateType {
  Pulled = "Pulled",
  Created = "Created"
}
